import { useState, useEffect } from "react";
import { Plus, Minus, Check } from "lucide-react";
import { FaUser } from "react-icons/fa6";
import Header from "../../lib/Common/Header";
import styles from "../../lib/Common/commonStyles";
import { getOffers, getAddress, offerCalculator } from "../../apis/Offers";
import { useFormik } from "formik";
import { numeratorSchema } from "../../validations/schema";
import TextInputFormik from "../../lib/Common/TextInputFormik";
import CommonButton from "../../lib/Common/Button";
import Footer from "../../lib/Common/Footer";
import Loader from "../../lib/Common/loader";
import {
  getTerifyName,
  calculateTariffDetails,
} from "../../lib/Common/definedFunctions";
import { AiFillThunderbolt } from "react-icons/ai";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { initialValues } from "../../validations/initialValues";
import { useTranslation } from "react-i18next";
import { buildWebsiteUrl } from "../../apis/apiKit";
import i18n from "../../i18n/i18n";
import {
  addCommasToNumber,
  germanToUSNumber,
} from "../../lib/Common/definedFunctions";
import { TooltipMessage } from "../../lib/Common/ToolTipmessage";
import Dropdown from "../../lib/Common/Dropdown";

const GreenmanEnergyForm = ({
  setStep,
  formValues,
  setValues,
  setFormData,
  step,
}) => {
  const { t } = useTranslation();
  const currentLanguage = i18n.language;
  const [currentStep, setCurrentStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const queryParams = new URLSearchParams(window.location.search);
  const [changable, setChangable] = useState(false);
  const paramValue = queryParams.get("code"); // Get the value of a specific parameter
  const [modified, setModified] = useState(false);
  const [streets, setStreets] = useState([]);
  const [streetLoading, setStreetLoading] = useState(false);
  const [zipError, setZipError] = useState(false);
  useEffect(() => {
    // if (step === 0) {
    setModified(formValues.modified);
    setChangable(false);
    const timeoutId = setTimeout(() => {
      setChangable(true);
    }, 1000);

    return () => {
      clearTimeout(timeoutId);
      setChangable(false);
    };
    // }
  }, [step]);

  useEffect(() => {
    if ((formValues?.postalCode && formValues?.street) || paramValue)
      getStreets({ target: { value: formValues?.postalCode || paramValue } });
  }, [formValues?.street, paramValue]);

  const getStreets = async (e) => {
    setZipError(false);
    setErrorMessage(false);
    const zipCode = e?.target?.value;
    if (!zipCode || zipCode?.length != 5) return false;
    setStreetLoading(true);
    if (zipCode != formValues?.postalCode) formik?.setFieldValue("street", "");
    const res = await offerCalculator({
      tariffName: "greenman_rlm_spot_business_generic",
      consumption: 1000,
      zipCode,
      hasSmartMeter: false,
    });
    if (
      !res.success &&
      res?.message?.streets &&
      res?.message?.streets.length > 0
    ) {
      const s = res?.message?.streets.map((st) => {
        return { value: st[0], label: st[0] };
      });
      setStreets(s);
      formik.setFieldValue("validStreet", true);
    } else if (!res.success) {
      if (res?.errorCode == "Error") {
        setZipError(true);
      }
      setStreets([]);
      formik.setFieldValue("validStreet", false);
      formik.setFieldValue("street", "");
    } else {
      formik.setFieldValue("validStreet", false);
      setStreets([]);
      formik.setFieldValue("street", "");
    }
    setStreetLoading(false);
  };
  const formik = useFormik({
    initialValues: {
      postalCode: formValues?.postalCode || paramValue,
      validStreets: formValues?.validStreets || false,
      street: formValues?.street || "",
      hasSmartMeter: formValues?.hasSmartMeter ?? null,
      customerType: formValues?.customerType || "",
      householdSize: formValues?.householdSize || 1,
      energyConsumption: formValues?.energyConsumption || "",
      email: formValues?.email || "",
      privacy: formValues?.privacy || false,
    },
    validationSchema: numeratorSchema,
    onSubmit: async (values) => {
      try {
        setErrorMessage(false);
        if (zipError) {
          setErrorMessage("Zipcode does not exist.");
          return false;
        }
        setLoading(true);
        if (formValues?.customerType) {
          if (formValues?.customerType != values?.customerType)
            setFormData(initialValues);
        }
        // let cleanValue = values?.energyConsumption.replace(/./g, "");
        // const clean = germanToUSNumber(values?.energyConsumption);
        // let consumptionValue = clean.replace(",", "");
        let consumptionValue = values?.energyConsumption.replace(/\./g, "");
        console.log("consumptionValue", consumptionValue);
        let yearSavings;
        // Consumption value should be less than 100000 to get the address and offers
        if (consumptionValue < 100000) {
          const result = await getAddress({ postalCode: values?.postalCode });
          if (result.success) {
            yearSavings = await getOffers({
              postalCode: values?.postalCode,
              energyConsumption: consumptionValue,
              street:
                !values.street || values.street == ""
                  ? result.result?.street
                  : values.street,
              city: result.result?.city,
            });
          }
        }
        let tariffName = await getTerifyName(
          values?.customerType,
          values?.hasSmartMeter,
          consumptionValue,
          values?.email
        );
        const res = await offerCalculator({
          tariffName,
          consumption: consumptionValue,
          street: !values.street || values.street == "" ? false : values.street,
          zipCode: values?.postalCode,
          hasSmartMeter: values?.hasSmartMeter,
          email: values?.email,
          householdSize: values?.householdSize,
          customerType: values?.customerType,
          privacy: values?.privacy,
        });
        if (res.success) {
          const data = [];
          if (Array.isArray(res?.result.data)) {
            localStorage.setItem("customer_id", res.result.id);
            const detailPromises = res.result.data.map((item) =>
              calculateTariffDetails(
                item,
                yearSavings?.result?.local_utility_year_price
              )
            );
            const calculatedDetails = await Promise.all(detailPromises);
            console.log("Calculated Tariff Details:", calculatedDetails);
            data.push(...calculatedDetails); // optional
          } else {
            console.error(
              "Expected res.data to be an array, but got:",
              res?.result
            );
          }

          setValues({
            ...values,
            payment_method:
              values?.customerType == "private" ? "direct_debit" : "",
            householdSize:
              values?.customerType == "private" ? values?.householdSize : null,
            data: data,
            yearSavings: yearSavings?.result?.local_utility_year_price,
            modified,
          });
          setStep(1);
        } else {
          if (res?.errorCode == "Error") {
            setErrorMessage("Zipcode does not exist.");
          } else if (typeof res?.message === "object") {
            setErrorMessage(res?.message?.zip_code[0]);
          } else {
            setErrorMessage(res?.message);
          }
          setTimeout(() => setErrorMessage(""), 10000);
          setLoading(false);
        }
        setLoading(false);
      } catch (error) {
        console.error("Error in form submission:", error);
        setLoading(false);
        setErrorMessage("An unexpected error occurred. Please try again.");
        setTimeout(() => setErrorMessage(""), 10000);
      }
    },
  });

  useEffect(() => {
    if (formik?.values?.customerType === "private") {
      let defaultEnergyConsumption = "";
      if (!modified) {
        switch (formik?.values?.householdSize) {
          case 1:
            defaultEnergyConsumption = "1.500";
            break;
          case 2:
            defaultEnergyConsumption = "2.500";
            break;
          case 3:
            defaultEnergyConsumption = "3.500";
            break;
          case 4:
            defaultEnergyConsumption = "4.500";
            break;
          case 5:
            defaultEnergyConsumption = "5.000";
            break;
          case 6:
            defaultEnergyConsumption = "5.500";
            break;
          default:
            defaultEnergyConsumption = "1.500"; // fallback value
        }
        // Only set value if field is empty (optional safety check)
        // if([1.500, 2.500, 3.500, 4.500])
        if (changable) {
          const finalValue = addCommasToNumber(defaultEnergyConsumption);
          formik.setFieldValue("energyConsumption", finalValue);
        }
      }
      // alert(defaultEnergyConsumption);
      // alert(formValues?.energyConsumption);
      // formik.setFieldValue("energyConsumption", defaultEnergyConsumption);
      // formik.blure
      //
      // const formattedValue = addCommasToNumber(defaultEnergyConsumption);
      // formik.setFieldValue(field, formattedValue);
    }
  }, [formik?.values?.householdSize, formik?.values?.customerType]);

  const isStepActive = (step) => step === currentStep;
  const isStepCompleted = (step) => {
    const values = formik.values || {};
    switch (step) {
      case 1:
        return (
          typeof values.postalCode === "string" &&
          values.postalCode.trim().length > 0
        );
      case "1_5":
        return (
          typeof values.street === "string" && values.street.trim().length > 0
        );
      case 2:
        return typeof values.hasSmartMeter === "boolean";
      case 3:
        return (
          typeof values.customerType === "string" &&
          values.customerType.trim() !== ""
        );
      case 4:
        return (
          typeof values.energyConsumption === "string" &&
          values.energyConsumption.length > 0
        );
      case 5:
        return typeof values.email === "string" && values.email.trim() !== "";
      default:
        return step < currentStep;
    }
  };

  const getStepStatus = (step) => {
    if (isStepActive(step)) return "active";
    if (isStepCompleted(step)) return "completed";
    return "inactive";
  };

  const navItem = (id, title = false) => {
    const getStepClasses = () => {
      let classes = `step-container step-${id}`;

      if (id == 5) {
        classes += " last-step";
      }
      switch (id) {
        case 1:
          classes += " form-content";
          break;
        case "1_5":
          classes += " dual-column-content";
          break;
        case 2:
          classes += " dual-column-content";
          break;
        case 3:
          classes += " dual-column-content";
          break;
        case 4:
          if (formik.values?.customerType === "private") {
            classes += `${
              currentLanguage === "de" ? " step4line" : ""
            } has-two-columns private-customer expanded-content`;
          } else if (formik.values?.customerType === "business") {
            classes += " business-customer form-content";
          } else {
            classes += " compact-content";
          }
          break;
        case 5:
          classes += " large-content";
          break;
        default:
          classes += " form-content";
      }

      return classes;
    };

    return (
      <div
        className={getStepClasses()}
        style={{
          marginBottom: id === 4 && !formik.values?.customerType ? "0" : "0",
        }}
      >
        <div
          className={`
    step-circle
    rounded-circle
    d-flex
    align-items-center
    justify-content-center
    fontSize15Bold
    text-blue
    ${
      getStepStatus(id) === "completed" || getStepStatus(id) === "active"
        ? "step-circle-active"
        : ""
    }
  `}
          style={{
            backgroundColor:
              getStepStatus(id) === "completed" ||
              getStepStatus(id) === "active"
                ? "#FF53FF"
                : "#B3A9BE",
          }}
        >
          {isStepCompleted(id) ? (
            <Check size={20} color="#421F66" />
          ) : id === "1_5" ? (
            <MdOutlineKeyboardArrowRight size={24} color="#421F66" />
          ) : (
            id
          )}
        </div>
        {title && (
          <div className=" d-flex align-items-center text-white flex-grow-1 mt-2 ms-2 ">
            <span className="fontSize15Regular lineHeight24">
              {t(`${title}`)}
            </span>
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <Header contract={true}></Header>
      {/* min-vh-100  */}
      <div className="responsive-padding backgroundColorCommon fontFamilyByker">
        <div className="container maxWidth700 ">
          <div className="row justify-content-center">
            <div className="col-12 ">
              <h2 className=" marginLeft65 mob-ml-0 mb-4 mb-md-5 fontSize32Bold lineHeight38 textGreen px-2">
                {t("Let's find the best price for you!")}
              </h2>

              <div className="px-2">
                <div className="step-line position-relative">
                  {/* Step 1: Postal Code */}
                  {/* <div className="mb-2 mb-md-4"> */}
                  <div className="mb-2 mb-md-4 minHeight90 ">
                    {navItem(1, "What is your postal code?")}
                    <div className="marginLeft65 mt-1 mt-md-2  position-relative">
                      <TextInputFormik
                        field="postalCode"
                        formik={formik}
                        max={5}
                        label=""
                        onChange={getStreets}
                        loading={streetLoading}
                        loadingStyle={
                          " text-pink position-absolute top20px right15px post_code_spinner"
                        }
                      />
                    </div>
                    {zipError && (
                      <div className="marginLeft65 fontSize14Medium lineHeight1_2 text-pink mt-n20px">
                        {t("Zipcode does not exist.")}
                      </div>
                    )}
                  </div>
                  {/* Step 1.5 */}
                  {streets && streets.length > 0 && (
                    // <div className="mb-2 mb-md-4">
                    <div className="mb-2 mb-md-4 minHeight90 ">
                      {navItem("1_5", "Street Address")}
                      <div className="marginLeft65 mt-1 mt-md-3">
                        <Dropdown
                          name="Street Address"
                          value={
                            formik.values?.street &&
                            streets.find(
                              (option) => option.value === formik.values?.street
                            )
                          }
                          placeholder=""
                          options={streets}
                          onChange={(value) => {
                            formik.setFieldValue("street", value.value);
                          }}
                        />
                        {(formik.submitCount > 0 || formik?.touched?.street) &&
                          formik?.errors?.street && (
                            <p className="fontSize14Medium lineHeight1_2 text-pink mt-1 mb-0">
                              {t(`${formik.errors.street}`)}
                            </p>
                          )}
                      </div>
                    </div>
                  )}

                  {/* Step 2: Smart Meter */}
                  {/* <div className="mb-2 mb-md-4"> */}
                  <div className="mb-2 mb-md-4 minHeight90 ">
                    <div className="d-flex align-items-center  ">
                      {navItem(2, "Do you have a smart meter?")}
                      <TooltipMessage
                        heading={"Smart Meter Gateway"}
                        Image={require("../../assets/images/smart_meter.png")}
                        message={
                          "The most obvious feature is an additional box, usually green or brown, attached to or next to the digital electricity meter."
                        }
                        heading1={"Digitale Anzeige"}
                        message2={
                          "Your meter has a digital display, but this alone does not guarantee that it is a smart meter. Conventional digital meters also have displays."
                        }
                        buttonClass={`mb-md-0 mb-2  `}
                      />
                    </div>

                    <div className="marginLeft65  mt-1 mt-md-3">
                      <div className="row g-3">
                        <CommonButton
                          formik={formik}
                          field="hasSmartMeter"
                          value={true}
                          title={t("Yes")}
                        />
                        <CommonButton
                          formik={formik}
                          field="hasSmartMeter"
                          value={false}
                          title={t("no")}
                        />
                      </div>
                      {(formik.submitCount > 0 ||
                        formik.touched?.hasSmartMeter) &&
                        formik.errors?.hasSmartMeter && (
                          <div className=" mt-1 fontSize14Medium lineHeight1_2 text-pink">
                            {t(`${formik.errors?.hasSmartMeter}`)}
                          </div>
                        )}
                    </div>
                  </div>

                  {/* Step 3: Customer Type */}
                  <div className="mb-2 mb-md-4 minHeight90">
                    {navItem(3, "What type of customer are you?")}
                    <div className="marginLeft65  mt-1 mt-md-3">
                      <div className="row g-3">
                        <CommonButton
                          formik={formik}
                          field="customerType"
                          value="private"
                          title={t("Private customer")}
                          // className=" "

                          className={`  ${
                            currentLanguage === "de" ? "col-12 col-sm-6" : ""
                          }`}
                        />
                        <CommonButton
                          formik={formik}
                          field="customerType"
                          value="business"
                          title={t("Business customer")}
                          className={`  ${
                            currentLanguage === "de" ? "col-12 col-sm-6" : ""
                          }`}
                        />
                      </div>
                      {(formik.submitCount > 0 ||
                        formik.touched?.customerType) &&
                        formik.errors?.customerType && (
                          <div className=" mt-1 fontSize14Medium lineHeight1_2 text-pink">
                            {t(`${formik.errors?.customerType}`)}
                          </div>
                        )}
                    </div>
                  </div>

                  {/* Step 4: Household/Energy Details - Only show if customer type is selected */}
                  {/* <div className="mb-1 "> */}
                  <div className={"mb-1 minHeight90 mt-3 mt-md-0"}>
                    {navItem(4)}
                    {formik.values?.customerType && (
                      <div className="marginLeft65 mob-top-gap-10 ">
                        {formik.values.customerType === "private" ? (
                          <div className="row marginNTop35">
                            {/* Household Size Counter */}
                            <div className="col-md-6 ">
                              {/* <div className=" align-items-center text-white mb-2 mb-md-4  fontSize15Regular minHeight48"> */}
                              <div
                                className={` align-items-center text-white mb-2 mb-md-4  fontSize15Regular ${
                                  currentLanguage === "de" ? "minHeight48" : ""
                                }`}
                              >
                                {t("How many people in your household?")}
                              </div>

                              <div
                                className="text-center d-flex align-items-center justify-content-center text-white py-2 px-2 py-md-3 px-md-4  py-sm-3 mb-2 mb-md-0 backgroundColorCommon borderRadius12"
                                style={{
                                  ...styles.border1pxSolidgreen,
                                }}
                              >
                                <button
                                  className="btn p-0 me-4 text-white rounded-circle d-flex align-items-center justify-content-center border-0 backgroundColorGreen height20 width20"
                                  onClick={() =>
                                    formik.setFieldValue(
                                      "householdSize",
                                      Math.max(
                                        1,
                                        formik.values?.householdSize - 1
                                      )
                                    )
                                  }
                                  disabled={formik.values?.householdSize == 1}
                                >
                                  <Minus size={10} color="#421F66" />
                                </button>
                                <div className="d-flex align-items-center">
                                  <FaUser
                                    size={15}
                                    className="me-3"
                                    color="#23DC9F"
                                  />
                                  <span className="fontSize15Bold lineHeight24">
                                    {formik.values?.householdSize}
                                  </span>
                                </div>
                                <button
                                  className="btn p-0 ms-4 text-white rounded-circle d-flex align-items-center justify-content-center border-0 backgroundColorGreen height20 width20"
                                  onClick={() => {
                                    if (formik.values?.householdSize < 6)
                                      formik.setFieldValue(
                                        "householdSize",
                                        formik.values?.householdSize + 1
                                      );
                                  }}
                                  disabled={formik.values?.householdSize == 6}
                                >
                                  <Plus size={10} color="#421F66" />
                                </button>
                              </div>
                            </div>
                            {/* Energy Consumption Input */}
                            <div className="col-md-6">
                              <div className="d-flex align-items-center  ">
                                {/* <div className="text-white fontSize15Regular mb-2 mb-md-4 minHeight48"> */}
                                <div
                                  className={` text-white fontSize15Regular mb-2 mb-md-4   ${
                                    currentLanguage === "de"
                                      ? "minHeight48"
                                      : ""
                                  }`}
                                >
                                  {t("Energy Consumption (kWh/year)")}
                                </div>
                                <TooltipMessage
                                  message={"consumption_tooltip"}
                                  buttonClass={`mb-md-0 mb-2 ${
                                    currentLanguage === "de"
                                      ? "mt-n48px"
                                      : "mt-n25px "
                                  }`}
                                />
                              </div>

                              <div className="position-relative">
                                <AiFillThunderbolt
                                  className="position-absolute ms-3 top20px"
                                  size={20}
                                  style={{ zIndex: 10 }}
                                  color="#23DC9F"
                                />
                                <TextInputFormik
                                  field="energyConsumption"
                                  formik={formik}
                                  type="text"
                                  customerType={"private"}
                                  householdsize={formik?.values?.householdSize}
                                  changable={changable}
                                  min={0}
                                  onChange={() => setModified(true)}
                                  //message="consumption_tooltip"
                                  style="ps-5 pe-5"
                                />
                                <div
                                  className="position-absolute top17px end-0 me-2 text-white ms-5 fontSize16Medium"
                                  style={{ pointerEvents: "none" }}
                                >
                                  kWh
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="mb-1  marginNTop38">
                            <div className="d-flex align-items-center mb-2 mb-md-4">
                              <div className="d-flex align-items-center text-white fontSize15Regular">
                                <span className="me-0">
                                  {t("Energy Consumption (kWh/year)")}
                                </span>
                                <TooltipMessage
                                  message={"consumption_tooltip"}
                                />
                              </div>
                            </div>

                            <div className="position-relative">
                              <AiFillThunderbolt
                                className="position-absolute ms-3 top20px"
                                size={20}
                                style={{ zIndex: 10 }}
                                color="#23DC9F"
                              />
                              <TextInputFormik
                                field="energyConsumption"
                                formik={formik}
                                type="text"
                                min={0}
                                //message="consumption_tooltip"

                                style="ps-5 pe-5"
                              />
                              <div
                                className="position-absolute top17px end-0 me-2 text-white ms-5 fontSize16Medium"
                                style={{ pointerEvents: "none" }}
                              >
                                kWh
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
                {/* Step 5: Email */}
                <div className="mb-1 mb-md-4 mt-3 mt-md-0">
                  {navItem(5)}
                  {formik.values?.customerType && (
                    <div className="marginLeft65  mt-0 mt-md-3 ">
                      <div className="marginNTop45">
                        <div className=" align-items-center text-white mb-2 mb-md-4  fontSize15Regular">
                          {t("Email address")}
                        </div>
                        <TextInputFormik
                          field="email"
                          formik={formik}
                          type="email"
                          placeholder={t("Email address")}
                        />
                      </div>
                      <div className="form-check d-flex align-items-start gap-2 mb-4   mt-4  mt-md-5 marginLeft1_3rem ">
                        <TextInputFormik
                          className="form-check-input mt-1 backgroundColorCommon borderColorlightgray cursor-pointer"
                          field="privacy"
                          formik={formik}
                          type="checkbox"
                        />
                        <label
                          className="form-check-label text-white lineHeight24 fontSize13Regular"
                          htmlFor="privacy"
                        >
                          {currentLanguage == "de" ? (
                            <>
                              {t("numerator_bottom")}
                              <a
                                href={buildWebsiteUrl("/de/datenschutz")}
                                className="textGreen text-decoration-none custom-pink-button"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {t("Privacy Statement")}.
                              </a>
                            </>
                          ) : (
                            <>
                              {t("numerator_bottom")}{" "}
                              <a
                                href={buildWebsiteUrl("/privacy-statement")}
                                className="textGreen text-decoration-none custom-pink-button"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {t("Privacy Statement")}
                              </a>{" "}
                              {t("for more details")}
                            </>
                          )}
                        </label>
                      </div>

                      {streetLoading || loading ? (
                        <div className="d-flex align-items-center justify-content-center">
                          <Loader loading={loading} />
                        </div>
                      ) : (
                        <>
                          {errorMessage && (
                            <p className="fontSize14Medium  text-pink mb-0">
                              {t(`${errorMessage}`)}
                            </p>
                          )}
                          <button
                            className="btn w-100 d-flex align-items-center justify-content-center border-0 rounded p-3 mt-2 mt-md-5 fontSize16Bold lineHeight18  cal-button custom-pink-button"
                            type="submit"
                            onClick={async () => {
                              formik.handleSubmit();
                            }}
                            onMouseOver={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                "#B24BF3")
                            }
                            onMouseOut={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                "#FF53FF")
                            }
                          >
                            {t("Calculate your tariff now!")}
                          </button>
                        </>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default GreenmanEnergyForm;
